module.exports = __webpack_public_path__ + "img/berne.0569c854.png";